import { Form, Input, Button, Space } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

import { AddAdministrationData } from "../../store";

const styles = {
  buttons: {
    float: "right" as const,
  },
};

interface Props {
  onSubmit?: (data: AddAdministrationData) => void;
  onCancel?: () => void;
}
const MultiversAdministration = (props: Props) => {
  const { onSubmit, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Form name="basic" onFinish={onSubmit}>
      <Form.Item
        label={t("Code")}
        name="code"
        rules={[
          {
            required: true,
            message: t("Please enter an administration code!"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <Space style={styles.buttons}>
          <Button htmlType="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Add
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default MultiversAdministration;
